<template>
  <span v-drag="{ direction: 'vertical', click: open }" class="kefu-btn">
    <span class="kefu-unread-tip" v-show="unReadNumber !== 0">{{
      unReadNumber
    }}</span>
    <img
      src="../../../assets/images/kefu/kefu.png"
      style="width: 24px; height: auto"
    />
    <div class="kefu-text">在线客服</div>
  </span>
</template>

<script>
import YSF from "@neysf/qiyu-web-sdk";
import { isEmpty } from "lodash";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      ysf: null,
      unReadNumber: 0,
    };
  },
  watch: {
    userInfo: {
      handler(value) {
        if (isEmpty(value)) {
          this.logoff();
        } else {
          this.ysfInit();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["companyInfo", "userInfo"]),
  },
  created() {},
  methods: {
    open() {
      this.ysf?.("open");
    },
    logoff() {
      this.ysf?.("logoff");
    },
    /**
     * 监听未读数量
     */
    watchUnreadMsg() {
      this.ysf("onunread", ({ total }) => {
        this.unReadNumber = total;
      });
    },
    /**
     * 获取未读数量
     */
    getUnreadMsg() {
      const { total } = this.ysf("getUnreadMsg");
      this.unReadNumber = total;
    },
    ysfInit() {
      if (isEmpty(this.userInfo)) {
        // 用户信息未加载完成，直接返回
        return;
      }

      /**
       * 初始化七鱼客服
       */
      YSF.init("fa0941cbabd1a72e359e8e8623b9f337", {
        hidden: true,
      })
        .then((data) => {
          this.ysf = data;

          // 用户信息
          const {
            tenant, //租户编码
            userId,
            name,
            organizationName,
          } = this.userInfo;
          // 初始化用户信息
          this.ysf("config", {
            uid: `${tenant}_${userId}`,
            robotShuntSwitch: 0,
            groupid: 483126010,
            data: JSON.stringify([
              { label: "公司名", value: organizationName },
              { label: "真实姓名", value: name },
            ]),
          });
          this.getUnreadMsg();
          this.watchUnreadMsg();
        })
        .catch((error) => {
          console.log("ysf加载失败", error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.kefu-btn {
  user-select: none;
  position: fixed;
  right: 0;
  width: 32px;
  bottom: 58px;
  z-index: 9999;
  padding: 8px 0;
  color: white;
  font-size: 12px;
  background: #0045f0;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.12), 0px 6px 18px rgba(0, 0, 0, 0.08),
    0px 9px 28px rgba(0, 0, 0, 0.06);
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  text-align: center;
  &:hover {
    background: #4080ff;
  }
  > .kefu-text {
    width: 12px;
    font-size: 12px;
    line-height: 14px;
    display: inline-block;
  }
  > .kefu-unread-tip {
    padding: 0 8px;
    height: 20px;
    line-height: 20px;
    border-radius: 100px;
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(-45%, -45%);
    background: #f53f3f;
  }
}
</style>
